import * as types from '../constants/lookup';
import * as toasterTypes from '../constants/ActionTypes';
import * as lookupApi from '../api/lookup';

export function getAddUserRoleLookup() {
    // console.log("getAddUserRoleLookup action call");
    return dispatch => {
        dispatch({ type: types.FETCH_LOOKUP_REQUEST });
        lookupApi.getAddUserRoleLookup()
            .then(function (response) {
                // console.log("getAddUserRoleLookup", response)
                dispatch({ type: types.FETCH_LOOKUP_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("getAddUserRoleLookup Error", err)
                dispatch({ type: types.FETCH_LOOKUP_REQUEST_ERROR, error: err });
            });
    }
}

exports.getAPIVersion = function () {
    console.log("getAPIVersion==>");
    return (dispatch, getState) => {
        let _state = getState()
        if (_state && _state.getAddUserRoleLookup.apiVersionInfo && _state.getAddUserRoleLookup.apiVersionInfo.version) {
            console.log('getAPIVersion loaded from CACHE',_state.getAddUserRoleLookup.apiVersionInfo.version)
        }
        else {
            dispatch({ type: types.FETCH_VERSION_LOOKUP_REQUEST });
            lookupApi.getAPIVersion()
                .then(function (response) {
                    console.log("getAPIVersion", response)
                    dispatch({ type: types.FETCH_VERSION_LOOKUP_REQUEST_COMPLETED, apiVersionInfo: response.data });
                })
                .catch(function (err) {
                    console.log("getAPIVersion Error", err)
                    dispatch({ type: types.FETCH_VERSION_LOOKUP_REQUEST_ERROR, error: err });
                });
        }
    }
}



// WEBPACK FOOTER //
// ./actions/lookup.js